import { SettingComponent } from "../../components";

export default function ScreenSettingPage() {
  return <SettingComponent.ScreenSettingPage />;
}
